"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  common: {
    ok: 'OK',
    error: 'Error',
    errorTitle: 'Error',
    success: 'Success',
    unexpectedError: 'Sorry, an unexpected error occurred. Please try again later.'
  },
  imageDocumentPreview: {
    error: 'Image preview not available'
  },
  pdfDocumentPreview: {
    pdfError: 'PDF preview not available',
    empty: 'There is no file'
  },
  date: {
    rangeFilterName: 'Date range',
    any: 'Any time',
    startDate: 'Start date',
    endDate: 'End date',
    rangeSeparator: 'to',
    placeholder: 'Date',
    presets: {
      today: 'Today',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      thisMonth: 'This month',
      lastMonth: 'Last month'
    }
  },
  tableFooter: {
    showing: 'Showing {{pageStart}} to {{pageEnd}} of {{totalItemsCount}} {{dataName}}',
    mobileShowing: 'Showing {{pageStart}} - {{pageEnd}} {{dataName}}'
  },
  emailBox: {
    emailInvoice: 'Email us your invoice (suppliers can use this too):',
    emailSupliersCompleteData: 'Email suppliers a link to complete their data:',
    emailSupliersSendQuote: 'Email suppliers a link to send a quote:',
    copied: 'Copied!'
  },
  amountCell: {
    converted: 'Converted:'
  },
  addFiltersToggle: {
    add: 'Add filters'
  },
  filtersLayout: {
    search: 'Search...'
  },
  settingsLayout: {
    title: 'Settings'
  },
  reportsLayout: {
    title: 'Reports'
  },
  additionalFiltersLayout: {
    filterBy: 'Filter by',
    apply: 'Apply filters',
    clear: 'Clear filters'
  },
  fileUploader: {
    buttonText: 'Upload file',
    fileSizeError: 'File size cannot exceed more than {{maxSizeMb}}MB.',
    defaultEmptyText: 'No file selected'
  },
  fileDropZone: {
    remove: 'Remove',
    browse: 'or browse here'
  },
  statusLabel: {
    approved: 'APPROVED',
    pending: 'PENDING',
    awaitingApproval: 'AWAITING APPROVAL',
    notSubmitted: 'NOT SUBMITTED',
    draft: 'DRAFT',
    cancelled: 'CANCELLED',
    declined: 'DECLINED',
    completed: 'COMPLETED'
  },
  errors: {
    pageNotFound: 'This page could not be found.',
    unexpectedError: 'Something went wrong, Please contact support.',
    returnToLogin: 'Return to login',
    error: 'Error',
    uiSettingsIssue: 'There is issue in the UI Settings.'
  },
  inputPassword: {
    hide: 'Hide',
    show: 'Show'
  },
  inputAmount: {
    popularGroup: 'Popular',
    otherGroup: 'Other'
  },
  phonePicker: {
    searchPlaceholder: 'Type to search...',
    noCountriesText: 'No countries found'
  },
  multiPhonePicker: {
    addNewLabel: 'Add additional phone number'
  },
  formField: {
    optional: '(Optional)'
  },
  dateCell: {
    futurePayment: 'Future payment'
  },
  multiSearchSelect: {
    all: 'All',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    noOptions: 'No options found'
  },
  currencies: {
    AED: 'United Arab Emirates dirham',
    AFN: 'Afghan afghani',
    ALL: 'Albanian lek',
    AMD: 'Armenian dram',
    ANG: 'Netherlands Antillean guilder',
    AOA: 'Angolan kwanza',
    ARS: 'Argentine peso',
    AUD: 'Australian dollar',
    AWG: 'Aruban florin',
    AZN: 'Azerbaijani manat',
    BAM: 'Bosnia and Herzegovina convertible mark',
    BBD: 'Barbados dollar',
    BDT: 'Bangladeshi taka',
    BGN: 'Bulgarian lev',
    BHD: 'Bahraini dinar',
    BIF: 'Burundian franc',
    BMD: 'Bermudian dollar',
    BND: 'Brunei dollar',
    BOB: 'Boliviano',
    BRL: 'Brazilian real',
    BSD: 'Bahamian dollar',
    BTN: 'Bhutanese ngultrum',
    BWP: 'Botswana pula',
    BYN: 'Belarusian ruble',
    BZD: 'Belize dollar',
    CAD: 'Canadian dollar',
    CDF: 'Congolese franc',
    CHF: 'Swiss franc',
    CLP: 'Chilean peso',
    CNY: 'Chinese yuan',
    COP: 'Colombian peso',
    CRC: 'Costa Rican colon',
    CUC: 'Cuban convertible peso',
    CVE: 'Cape Verde escudo',
    CZK: 'Czech koruna',
    DJF: 'Djiboutian franc',
    DKK: 'Danish krone',
    DOP: 'Dominican peso',
    DZD: 'Algerian dinar',
    EGP: 'Egyptian pound',
    ERN: 'Eritrean nakfa',
    ETB: 'Ethiopian birr',
    EUR: 'Euro',
    FJD: 'Fiji dollar',
    FKP: 'Falkland Islands pound',
    GBP: 'Pound sterling',
    GEL: 'Georgian lari',
    GHS: 'Ghanaian cedi',
    GIP: 'Gibraltar pound',
    GMD: 'Gambian dalasi',
    GNF: 'Guinean franc',
    GTQ: 'Guatemalan quetzal',
    GYD: 'Guyanese dollar',
    HKD: 'Hong Kong dollar',
    HNL: 'Honduran lempira',
    HRK: 'Croatian kuna',
    HTG: 'Haitian gourde',
    HUF: 'Hungarian forint',
    IDR: 'Indonesian rupiah',
    ILS: 'Israeli new shekel',
    INR: 'Indian rupee',
    IQD: 'Iraqi dinar',
    IRR: 'Iranian rial',
    ISK: 'Icelandic krona',
    JMD: 'Jamaican dollar',
    JOD: 'Jordanian dinar',
    JPY: 'Japanese yen',
    KES: 'Kenyan shilling',
    KGS: 'Kyrgyzstani som',
    KHR: 'Cambodian riel',
    KMF: 'Comoro franc',
    KPW: 'North Korean won',
    KRW: 'South Korean won',
    KWD: 'Kuwaiti dinar',
    KYD: 'Cayman Islands dollar',
    KZT: 'Kazakhstani tenge',
    LAK: 'Lao kip',
    LBP: 'Lebanese pound',
    LKR: 'Sri Lankan rupee',
    LRD: 'Liberian dollar',
    LSL: 'Lesotho loti',
    LYD: 'Libyan dinar',
    MAD: 'Moroccan dirham',
    MDL: 'Moldovan leu',
    MGA: 'Malagasy ariary',
    MKD: 'Macedonian denar',
    MMK: 'Myanmar kyat',
    MNT: 'Mongolian togrog',
    MOP: 'Macanese pataca',
    MRO: 'Mauritanian ouguiya',
    MUR: 'Mauritian rupee',
    MVR: 'Maldivian rufiyaa',
    MWK: 'Malawian kwacha',
    MXN: 'Mexican peso',
    MYR: 'Malaysian ringgit',
    MZN: 'Mozambican metical',
    NAD: 'Namibian dollar',
    NGN: 'Nigerian naira',
    NIO: 'Nicaraguan cordoba',
    NOK: 'Norwegian krone',
    NPR: 'Nepalese rupee',
    NZD: 'New Zealand dollar',
    OMR: 'Omani rial',
    PAB: 'Panamanian balboa',
    PEN: 'Peruvian Sol',
    PGK: 'Papua New Guinean kina',
    PHP: 'Philippine peso',
    PKR: 'Pakistani rupee',
    PLN: 'Polish zloty',
    PYG: 'Paraguayan guarani',
    QAR: 'Qatari riyal',
    RON: 'Romanian leu',
    RSD: 'Serbian dinar',
    RUB: 'Russian ruble',
    RWF: 'Rwandan franc',
    SAR: 'Saudi riyal 2',
    SBD: 'Solomon Islands dollar',
    SCR: 'Seychelles rupee',
    SDG: 'Sudanese pound',
    SEK: 'Swedish krona/kronor',
    SGD: 'Singapore dollar',
    SHP: 'Saint Helena pound',
    SLL: 'Sierra Leonean leone',
    SOS: 'Somali shilling',
    SRD: 'Surinamese dollar',
    SSP: 'South Sudanese pound',
    STD: 'Sao Tome and Principe dobra',
    SVC: 'Salvadoran colon',
    SYP: 'Syrian pound',
    SZL: 'Swazi lilangeni',
    THB: 'Thai baht',
    TJS: 'Tajikistani somoni',
    TMT: 'Turkmenistani manat',
    TND: 'Tunisian dinar',
    TOP: "Tongan pa'anga",
    TRY: 'Turkish lira',
    TTD: 'Trinidad and Tobago dollar',
    TWD: 'New Taiwan dollar',
    TZS: 'Tanzanian shilling',
    UAH: 'Ukrainian hryvnia',
    UGX: 'Ugandan shilling',
    USD: 'United States dollar',
    UYU: 'Uruguayan peso',
    UZS: 'Uzbekistan som',
    VEF: 'Venezuelan bolivar',
    VND: 'Vietnamese dong',
    VUV: 'Vanuatu vatu',
    WST: 'Samoan tala',
    YER: 'Yemeni rial',
    ZAR: 'South African rand',
    ZMW: 'Zambian kwacha',
    ZWL: 'Zimbabwean dollar'
  },
  countries: {
    AF: 'Afghanistan',
    AX: 'Åland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Ant and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia, Plurinational State of',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, The Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Côte D'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea, Democratic People's Republic of",
    KR: 'Korea, Republic of',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia, The Former Yugoslav Republic of',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States of',
    MD: 'Moldova, Republic of',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan Da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French Part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tomé and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch Part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan, Province of China',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela, Bolivarian Republic of',
    VN: 'Vietnam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe'
  },
  states: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  inlineEdit: {
    save: 'Save',
    cancel: 'Cancel'
  },
  formPageLayout: {
    discard: 'Discard and go back'
  },
  multiSelect: {
    clearAll: 'Clear all'
  },
  filterMultiSelect: {
    andMore: 'and {{count}} more'
  },
  inlineEditTrigger: {
    edit: 'Edit'
  },
  searchSelect: {
    noOptions: 'No options'
  },
  cardDetails: {
    title: 'Card details: x{{lastDigits}}',
    detailsHeader: 'Card details',
    data: {
      number: 'Card number',
      holder: 'Card holder',
      expiryDate: 'Expiry date'
    },
    billingInformation: 'Billing information',
    billingAddress: 'Billing Address',
    vatNumber: 'VAT number',
    closeCardDetails: 'Close card details',
    copyNumber: 'Copy number',
    copied: 'Copied'
  },
  addressPicker: {
    enterAddressManually: 'Can’t see your address? Enter manually'
  },
  panelDocumentInfo: {
    download: 'Download',
    noDocument: 'Document not uploaded'
  },
  accountBalances: {
    availableBalance: 'Available balance'
  },
  payAccountlayout: {
    loading: 'Loading...',
    select: 'Select'
  }
};
exports.default = _default;